import {
    GET_ACCESSPROFILE_START,
    GET_ACCESSPROFILE_FAILURE,
    GET_ACCESSPROFILE_SUCCESS,
    GET_ACCESSPROFILE_RESET,
    CREATE_ACCESSPROFILE_START,
    CREATE_ACCESSPROFILE_SUCCESS,
    CREATE_ACCESSPROFILE_FAILURE,
    CREATE_ACCESSPROFILE_RESET,
    GET_ROUTES_START,
    GET_ROUTES_FAILURE,
    GET_ROUTES_SUCCESS,
    GET_ROUTES_RESET,
    ASSIGN_ROUTES_START,
    ASSIGN_ROUTES_SUCCESS,
    ASSIGN_ROUTES_FAILURE,
    ASSIGN_ROUTES_RESET,
    GET_EMPROUTES_START,
    GET_EMPROUTES_FAILURE,
    GET_EMPROUTES_SUCCESS,
    GET_EMPROUTES_RESET,
    GET_ACCESSEMPLOYEE_START,
    GET_ACCESSEMPLOYEE_SUCCESS,
    GET_ACCESSEMPLOYEE_FAILURE,
    GET_ACCESSEMPLOYEE_RESET,
    UPDATE_ACCESSPROFILE_START,
    UPDATE_ACCESSPROFILE_SUCCESS,
    UPDATE_ACCESSPROFILE_RESET,
    UPDATE_ACCESSPROFILE_FAILURE,
    GET_OTHER_ROUTES,
    GET_OTHER_ROUTES_SUCCESS,
    UPDATE_OTHER_ROUTES,
    UPDATE_OTHER_ROUTES_SUCCESS,
    UPDATE_OTHER_ROUTES_FAILED,
    GETMY_OTHER_ROUTES,
    GETMY_OTHER_ROUTES_SUCCESS,
    GETMY_OTHER_ROUTES_FAILED,

  } from "./actionTypes"


  // to create access profiles


  export const createAccessProfileStart = payload => {
    console.log(payload)
    return {
      type: CREATE_ACCESSPROFILE_START,
      payload: payload,
    }
  }
  
  export const createAccessProfileSuccess = payload => {
   // console.log(payload)
    return {
      type: CREATE_ACCESSPROFILE_SUCCESS,
      payload: payload,
    }
  }
  
  export const createAccessProfileFailure = error => {
    return {
      type: CREATE_ACCESSPROFILE_FAILURE,
      payload: error,
    }
  }
  
  export const createAccessProfileReset = () => {
    return {
      type: CREATE_ACCESSPROFILE_RESET,
    }
  }
  
  // GET Access PROFILE
  
  export const GetAccessProfileStart = () => {
    return {
      type: GET_ACCESSPROFILE_START,
    }
  }
  
  export const GetAccessProfileSuccess = payload => {
    return {
      type: GET_ACCESSPROFILE_SUCCESS,
      payload: payload,
    }
  }
  
  export const GetAccessProfileFailure = error => {
    return {
      type: GET_ACCESSPROFILE_FAILURE,
      payload: error,
    }
  }
  
  export const GetAccessProfileReset = () => {
    return {
      type: GET_ACCESSPROFILE_RESET,
    }
  }
  
  // GET Routes
  
  export const GetRoutesStart = () => {
    return {
      type: GET_ROUTES_START,
    }
  }
  
  export const GetRoutesSuccess = payload => {
    return {
      type: GET_ROUTES_SUCCESS,
      payload: payload,
    }
  }
  
  export const GetRoutesFailure = error => {
    return {
      type: GET_ROUTES_FAILURE,
      payload: error,
    }
  }
  
  export const GetRoutesReset = () => {
    return {
      type: GET_ROUTES_RESET,
    }
  }


  // Assign profiles to employee

  export const assignRoutesStart = payload => {
    console.log(payload)
    return {
      type: ASSIGN_ROUTES_START,
      payload: payload,
    }
  }
  
  export const assignRoutesSuccess = payload => {
    console.log(payload)
    return {
      type: ASSIGN_ROUTES_SUCCESS,
      payload: payload,
    }
  }
  
  export const assignRoutesFailure = error => {
    return {
      type: ASSIGN_ROUTES_FAILURE,
      payload: error,
    }
  }
  
  export const assignRoutesReset = () => {
    return {
      type: ASSIGN_ROUTES_RESET,
    }
  }
  

   
  // GET Assigned Routes of specific emp
  
  export const GetEmpRoutesStart = (payload) => {
    return {
      type: GET_EMPROUTES_START,
      payload:payload,
    }
  }
  
  export const GetEmpRoutesSuccess = payload => {
    return {
      type: GET_EMPROUTES_SUCCESS,
      payload: payload,
    }
  }
  
  export const GetEmpRoutesFailure = error => {
    return {
      type: GET_EMPROUTES_FAILURE,
      payload: error,
    }
  }
  
  export const GetEmpRoutesReset = () => {
    return {
      type: GET_EMPROUTES_RESET,
    }
  }




  // Get employee

  
   export const GetAccessEmployeeStart = () => {
    return {
      type: GET_ACCESSEMPLOYEE_START,
    }
  }
  
  export const GetAccessEmployeeSuccess = payload => {
    return {
      type: GET_ACCESSEMPLOYEE_SUCCESS,
      payload: payload,
    }
  }
  
  export const GetAccessEmployeeFailure = error => {
    return {
      type: GET_ACCESSEMPLOYEE_FAILURE,
      payload: error,
    }
  }
  
  export const GetAccessEmployeeReset = () => {
    return {
      type: GET_ACCESSEMPLOYEE_RESET,
    }
  }

  export const updateAccessProfileStart = (payload) =>{
    return {
      type: UPDATE_ACCESSPROFILE_START,
      payload
    }
  }

  export const updateAccessProfileSuccess = (payload) =>{
    return{
      type: UPDATE_ACCESSPROFILE_SUCCESS,
      payload
    }
  }

  export const updateAccessProfileFailure = (payload) =>{
    return{
      type: UPDATE_ACCESSPROFILE_FAILURE,
      payload
    }
  }

  export const updateAccessProfileReset = (payload) =>{
    return{
      type: UPDATE_ACCESSPROFILE_RESET,
      payload
    }
  }


  export const getAccessOtherRoutes = () =>{
    return{
      type: GET_OTHER_ROUTES
    }
  }


  export const getAccessOtherRoutesSuccess = (payload) =>{
    return{
      type: GET_OTHER_ROUTES_SUCCESS,
      payload
    }
  }


  export const getAccessOtherRoutesFailed = (payload) =>{
    return{
      type: GET_OTHER_ROUTES,
      payload
    }
  }


  export const updateAccessOtherRoutes = (payload) =>{
    return{
      type: UPDATE_OTHER_ROUTES,
      payload
    }
  }


  export const updateAccessOtherRoutesSuccess = (payload) =>{
    return{
      type: UPDATE_OTHER_ROUTES_SUCCESS,
      payload
    }
  }


  export const updateAccessOtherRoutesFailed = (payload) =>{
    return{
      type: UPDATE_OTHER_ROUTES_FAILED,
      payload
    }
  }



  export const getMyAccessOtherRoutes = (payload) =>{
    return{
      type: GETMY_OTHER_ROUTES,
      payload
    }
  }


  export const getMyAccessOtherRoutesSuccess = (payload) =>{
    return{
      type: GETMY_OTHER_ROUTES_SUCCESS,
      payload
    }
  }


  export const getMyAccessOtherRoutesFailed = (payload) =>{
    return{
      type: GETMY_OTHER_ROUTES_FAILED,
      payload
    }
  }